import React from 'react'

const Header = () => {
  return (
    <>
      <div className='header'>
        <h3>Shaon's All Projects</h3>
        <a href="https://shaontechnical.blogspot.com/" target="_blank" className='HeaderButton'>Home</a>
      </div>
    </>
  )
}

export default Header
